import React, { Component } from 'react';
import { firebaseApp, clearAuthCache, setAuthCache, setManageMyEvents } from "./api/FirebaseAPI";
import MenuAppBar from "./containers/MenuAppBar";
import Footer from "./containers/Footer";
import Main from "./components/Main";
import "./App.css"


/*
darkOrange: "#ec6f32",
lightOrange: "#ef9b67"
*/
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthorised: false,
      isAuthorising:true
    };
  }

  componentDidMount() {
    this.removeAuthListener = firebaseApp.auth().onAuthStateChanged((user) => {
      if (user) {
        setAuthCache(user);
        this.setState({
          isAuthorised: true,
          isAuthorising: false,
        });
        setManageMyEvents();
      } else {
        clearAuthCache()
        this.setState({
          isAuthorised: false,
        });
        console.log("User NOT Authorised")
      }
    });
  }

  render() {
    return (
      <div className="App">
        <MenuAppBar {...this.state}/>
        <Main {...this.state}/>
        <Footer />
      </div>

    );
  }
}

export default App;

/*

https://material.io/guidelines/style/color.html#color-color-palette

            //
*/



// WEBPACK FOOTER //
// ./src/App.js